import React from "react";
import { ServerComponentCaller } from "../../helpers";

const NoOlvidarEstudiarEstoClaseC = (props) => (
  <ServerComponentCaller url={"assets/data/pages/tips/tipsClaseC.json"} />
);

export default NoOlvidarEstudiarEstoClaseC;
